var _rect, _path, _rect2, _rect3, _rect4, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Insights into customer communication") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23,
    width: 112,
    height: 80,
    rx: 8,
    fill: "#D7E0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 39h40",
    stroke: "#A6B2C2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 72,
    width: 13,
    height: 18,
    rx: 3,
    fill: "#B69782"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 61,
    width: 13,
    height: 29,
    rx: 3,
    fill: "#A6B2C2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 48,
    width: 13,
    height: 42,
    rx: 3,
    fill: "#45556D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 85,
    r: 20,
    fill: "#DEEEE2",
    stroke: "#596475",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m133 100 14 15",
    stroke: "#596475",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m108 91 7-9 7 4 9-12",
    stroke: "#357653",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureInsight);
export default __webpack_public_path__ + "static/media/feature-insight.5c2db9e49fd37604c114b460a86c0226.svg";
export { ForwardRef as ReactComponent };